<template>
  <section class="section is-fullheight animated preFadeInUp fadeInUp">
    <div class="container">
      <!-- Title -->

      <div class="columns has-text-centered is-centered" v-if="loading">
        <loading
          font-size="20"
          line-fg-color="var(--primary-color)"
          size="massive"
          class="margin-100"
          text-fg-color="#2d3f51"
          message="الرجاء الإنتظار"
        />
      </div>
      <div v-else>
        <div class="section-title-wrapper has-text-centered mt-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-bell"></i>
          </div>
          <div>
            <h6
              class="clean-section-title has-text-black has-text-weight-bold is-small"
            >
              التنبيهات
            </h6>
            <h2
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold"
            >
              جميع التنبيهات
            </h2>
          </div>
        </div>

        <div class="columns is-vcentered is-multiline pt-30">
          <div class="column is-6 is-offset-3">
            <div class="mt-60"></div>

            <article
              class="message icon-msg primary-msg"
              :class="{ 'message info-msg': notification.service == 'visa' }"
              v-for="notification in notifications"
              v-bind:key="notification.id"
            >
              <i class="material-icons is-info">credit_card</i>
              <div class="message-body">
                <h4 v-if="notification.service == 'visa'">خدمات فيزا</h4>
                <h4 v-if="notification.service == 'zad'">خدمات تجوال</h4>
                <h4 v-if="notification.service == 'familyFCP'">
                  خدمات المالية
                </h4>
                <h4 v-if="notification.service == 'mobiCash'">
                  خدمات موبي كاش
                </h4>

                <h4>{{ notification.Title }}</h4>
                <strong>{{ notification.Content }}</strong>
                <h4>{{ notification.createdAt }}</h4>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import { async } from "q";
moment.locale("ar");

export default {
  name: "portal",

  data() {
    return {
      notifications: null,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    var user = JSON.parse(localStorage.getItem("user"));

    axios
      .get("customer/getNotifications/" + user[1])
      .then((response) => {
        this.$root.kick(response.data.message);
        this.notifications = response.data.results;

        // this.notifications.map(obj => {
        //   obj.flag = "vs";
        //   obj.date = obj.createdAt;
        //   obj.createdAt = moment(obj.createdAt).fromNow();
        //   return obj;
        // });

        console.log(this.notifications);

        this.loading = false;
      })
      .catch((error) => {
        // this.$router.push('/');
      });
  },
};
</script>
